<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- TOAST -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- ENCABEZADO -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Habitaciones en Mantenimiento</h3>
        <button class="btn btn-primary" @click="abrirModal">Agregar a Mantenimiento</button>
      </div>

      <!-- LISTA EN MANTENIMIENTO -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Número</th>
              <th>Tipo</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="habitacionesMantenimiento.length === 0">
              <td colspan="4">No hay habitaciones en mantenimiento.</td>
            </tr>
            <tr v-for="hab in habitacionesMantenimiento" :key="hab.IdHabitacion">
              <td>{{ hab.Numero }}</td>
              <td>{{ hab.tipo?.Nombre }}</td>
              <td>{{ hab.estado?.Estado }}</td>
              <td>
                <button class="btn btn-success btn-sm" @click="abrirModalConfirmarQuitar(hab)">
                  Quitar de Mantenimiento
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- MODAL AGREGAR -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Habitación a Mantenimiento</h5>
            <button type="button" class="btn-close" @click="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <label class="form-label">Selecciona una habitación:</label>
            <select v-model="habitacionSeleccionada" class="form-select mb-3">
              <option disabled value="">-- Selecciona --</option>
              <option v-for="hab in habitacionesDisponibles" :key="hab.IdHabitacion" :value="hab.IdHabitacion">
                {{ hab.Numero }} - {{ hab.tipo?.Nombre }}
              </option>
            </select>

            <div class="form-check">
              <input type="checkbox" class="form-check-input" v-model="confirmar" id="confirmarCheckbox">
              <label class="form-check-label" for="confirmarCheckbox">Confirmar poner en mantenimiento</label>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" :disabled="!habitacionSeleccionada || !confirmar" @click="guardarMantenimiento">
              Guardar Cambios
            </button>
          </div>
        </div>
      </div>

      <!-- MODAL CONFIRMAR QUITAR -->
      <div v-if="mostrarModalQuitar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Acción</h5>
            <button type="button" class="btn-close" @click="cerrarModalQuitar"></button>
          </div>
          <div class="modal-body">
            <p>
              ¿Estás seguro de quitar la habitación 
              <strong>{{ habitacionAEliminar?.Numero }}</strong> 
              de mantenimiento?
            </p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cerrarModalQuitar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarQuitarMantenimiento">Sí, Quitar</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from "@/config/config.js";

export default {
  name: "HabitacionesMantenimiento",
  data() {
    return {
      habitacionesDisponibles: [],
      habitacionesMantenimiento: [],
      habitacionSeleccionada: null,
      confirmar: false,
      mostrarModal: false,
      mostrarModalQuitar: false,
      habitacionAEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: '', tipo: 'success' },
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === 'success' ? 'bg-success' : 'bg-danger';
    },
    iconoToast() {
      return this.alerta.tipo === 'success' ? 'bi bi-check-circle' : 'bi bi-exclamation-circle';
    },
  },
  methods: {
    async abrirModal() {
      this.mostrarModal = true;
      this.habitacionSeleccionada = null;
      this.confirmar = false;
      await this.cargarHabitacionesDisponibles();
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.habitacionSeleccionada = null;
      this.confirmar = false;
    },
    async guardarMantenimiento() {
      try {
        await axios.put(`${API_URL}/habitaciones/${this.habitacionSeleccionada}/mantenimiento`, {
          marcar: true
        });
        this.mostrarAlerta("Habitación marcada en mantenimiento");
        this.cerrarModal();
        this.cargarHabitacionesMantenimiento();
        this.cargarHabitacionesDisponibles();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar.", "danger");
      }
    },
    abrirModalConfirmarQuitar(habitacion) {
      this.habitacionAEliminar = habitacion;
      this.mostrarModalQuitar = true;
    },
    cerrarModalQuitar() {
      this.habitacionAEliminar = null;
      this.mostrarModalQuitar = false;
    },
    async confirmarQuitarMantenimiento() {
      try {
        await axios.put(`${API_URL}/habitaciones/${this.habitacionAEliminar.IdHabitacion}/mantenimiento`, {
          marcar: false
        });
        this.mostrarAlerta("Habitación disponible nuevamente");
        this.cerrarModalQuitar();
        this.cargarHabitacionesMantenimiento();
        this.cargarHabitacionesDisponibles();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar.", "danger");
      }
    },
    async cargarHabitacionesMantenimiento() {
      try {
        const res = await axios.get(`${API_URL}/habitaciones-en-mantenimiento`);
        this.habitacionesMantenimiento = res.data || [];
      } catch (error) {
        console.error(error);
      }
    },
    async cargarHabitacionesDisponibles() {
      try {
        const res = await axios.get(`${API_URL}/habitaciones-para-mantenimiento`);
        this.habitacionesDisponibles = res.data.habitaciones || [];
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al cargar habitaciones.", "danger");
      }
    },
    mostrarAlerta(mensaje, tipo = 'success') {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    cerrarToast() {
      this.mostrarToast = false;
    },
  },
  mounted() {
    this.cargarHabitacionesMantenimiento();
    this.cargarHabitacionesDisponibles();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 500px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
